// extracted by mini-css-extract-plugin
export var content = "_dp-3";
export var list = "_dp-4";
export var settingsContent = "_dp-7";
export var settingsPanel = "_dp-8";
export var state = "_dp-6";
export var triggerBadge = "_dp-2";
export var triggerButton = "_dp-1";
export var triggerShell = "_dp-0";
export var unreadDot = "_dp-5";